import React from 'react';
import { ReactComponent as CloseSVG } from 'assets/xCircle.svg';
import {
  Box,
  Grid,
  IconButton,
  Paper,
  SxProps,
  Typography,
} from '@mui/material';
import { colors } from 'styles/colors';
import { WithTranslation, withTranslation } from 'react-i18next';
import { ReactComponent as InfoIcon } from 'assets/InfoIcon.svg';
export interface IInfoPaperProps extends WithTranslation  {
  children: React.ReactNode; // ✅ FIXED
  onCancelIcon?: () => Promise<void>;
  paperSx?: SxProps;
  infoSx?: SxProps;
  childrenGridSx?: SxProps;
  childrenTypographySx?: SxProps;
  warning?: boolean;
  error?: boolean;
  header?: React.ReactNode;
  id?: string;
  disableTabIndex?: boolean;
}

export const InfoPaper = ({
  children,
  header,
  onCancelIcon,
  paperSx,
  infoSx,
  childrenGridSx,
  childrenTypographySx,
  warning,
  error,
  id,
  disableTabIndex,
  t,
}: IInfoPaperProps ): React.ReactElement => (
  <Paper
    sx={{
      border: 'none',
      backgroundColor: ({ palette }) =>
        warning
          ? palette.info?.dark + '1A'
          : error
          ? palette.background?.errorLight
          : palette.navy?.main + '1A',
      padding: ({ spacing }) => `${spacing(2)} ${spacing(3)}`,
      borderRadius: '4px',
      ...paperSx,
    }}
    id={id}
    data-testid={id}
    aria-label={id != null ? String(id) : undefined}
    tabIndex={disableTabIndex ? -1 : 0}
  >
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        alignItems="center"
        justifyContent="flex-start"
        sx={{
          ml: '-0.5rem',
          ':focus': { width: 'fit-content' },
          ...infoSx,
        }}
        aria-label={`${t('infoIcon')}`}
        tabIndex={0}
      >
        <InfoIcon
          color={
            warning
              ? colors.hightlight.dark
              : error
              ? colors.status.error
              : colors.tertiary.navy
          }
        />
      </Grid>
      {header && (
        <Grid
          container
          flexWrap="nowrap"
          alignItems="center"
          sx={{ mt: '-1.5rem', ml: '1.5rem', mb: '1.625rem' }}
        >
          <Typography className="kfic2-bodyTextBold">{header}</Typography>
        </Grid>
      )}
      <Grid
        container
        flexWrap="nowrap"
        alignItems="center"
        sx={{
          mt: '-1.5rem',
          mx: '1.5rem',
          ':focus': { width: 'fit-content' },
          ...childrenGridSx,
        }}
      >
        <Typography
          className="kfic2-bodyText"
          id="children"
          aria-label="children"
          tabIndex={0}
          sx={{ ...childrenTypographySx }}
        >
          {children}
        </Typography>
      </Grid>
      {onCancelIcon && (
        <Grid
          container
          alignItems="center"
          justifyContent="flex-end"
          sx={{ mt: '-1.5rem' }}
        >
          <IconButton
            id={`cancelIcon_info_banner-${id}`}
            data-testid={`cancelIcon_info_banner-${id}`}
            aria-label="close"
            onClick={onCancelIcon}
            sx={{ padding: 0 }}
          >
            <CloseSVG />
          </IconButton>
        </Grid>
      )}
    </Box>
  </Paper>
);

export default withTranslation()(InfoPaper);